import { Injectable } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, take } from 'rxjs/operators';

import { ExportService, GridService, NotificationService } from '@core/services';

import * as ExportActions from './export.actions';

@Injectable()
export class ExportEffects {
  constructor(
    private actions$: Actions,
    private gridService: GridService,
    private exportService: ExportService,
    private notificationService: NotificationService
  ) {}

  RequestDataForExportSuccess$ = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(ExportActions.RequestDataForExportSuccess),
        map(({ id, format, data }) => {
          this.gridService
            .grid$(id)
            .pipe(take(1))
            .subscribe((grid) => {
              this.exportService.data$.next({ columns: grid.selectedColumns, format, data });
            });
        })
      );
    },
    { dispatch: false }
  );

  RequestDataForExportFailure$ = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(ExportActions.RequestDataForExportFailure),
        map(({ error }) => {
          this.exportService.data$.next(null);
          this.exportService.loading$.next(false);

          this.notificationService.error({
            title: `Error ${error?.error?.error?.errorCode as string}`,
            message: `${error?.error?.error?.message as string}`,
          });
        })
      );
    },
    { dispatch: false }
  );
}
